<nb-card class="basic-card">
  <nb-card-header>
    @if (gainType === 'ENERGY') {
      {{ "Desired gains" | translate }}
    } @else if (gainType === 'CARBON') {
      {{ "Gain" | translate }} {{ "pages.energy.kg_CO2" | translate }}
    }
  </nb-card-header>
  <nb-card-body>
    <table>
      <thead>
        <tr>
          <th class="text-center">#</th>
          <th>
            {{ "Gain" | translate }}
            @if (gainType === 'ENERGY') {
              {{ "kWh" | translate }}
            } @else if (gainType === 'CARBON') {
              {{ "pages.energy.kg_CO2" | translate }}
            }
          </th>
          <th>
            {{ "Related energy" | translate }}
          </th>
          <th>{{ "Precision on the gain" | translate }}</th>
          <th>{{ "Origin of the gain" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (gain of (gains$ | async); track gain.id; let index = $index) {
          <tr>
            <td class="text-center">{{ index + 1 }}</td>
            @if (gainType === 'ENERGY') {
              <td>{{ gain.kwhSavings | thousandsSeparator }}</td>
              <td>{{ gain.energyTypeName }}</td>
            } @else if (gainType === 'CARBON') {
              <td>{{ gain.co2Savings | thousandsSeparator }}</td>
              <td></td>
            }
            <td>{{ gain.precision?.name || '-' }}</td>
            <td>{{ gain.origin?.name || '-' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </nb-card-body>
</nb-card>
